import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export enum LANGUAGES {
  EN = "en",
  JP = "jp",
  CN = "cn",
}

// languages that live under a url prefix like /jp/ or /cn/
const PREFIXED_LANGUAGES = [LANGUAGES.JP, LANGUAGES.CN];

export const useLanguageRedirect = () => {
  const navigate = useNavigate();

  // Default to EN if no language is set
  const language = localStorage.getItem("lang") || LANGUAGES.EN;

  useEffect(() => {
    const path = window.location.pathname;
    const currentPrefix = PREFIXED_LANGUAGES.find((lang) =>
      path.startsWith(`/${lang}/`)
    );

    // EN → Normal routes (no language prefix)
    if (language === LANGUAGES.EN && !currentPrefix) return;

    // JP/CN → Must always have the matching prefix
    if (language === currentPrefix) return;

    // Remove the existing language prefix
    let newPath = currentPrefix
      ? path.replace(`/${currentPrefix}/`, "/")
      : path;

    if (language !== LANGUAGES.EN) {
      // Convert /en/ or / → prefixed path
      if (newPath.startsWith("/en/")) {
        newPath = newPath.replace("/en/", "/");
      }
      newPath = newPath === "/" ? `/${language}/` : `/${language}${newPath}`;
    }

    if (newPath !== path) {
      navigate(newPath);
      setTimeout(() => window.location.reload(), 100);
    }
  }, [language, navigate]);

  return {
    language,
  };
};
